<template>
    <div>
        <b-modal id="editMaterial"
                 title="Редактирование материала"
                 @ok="submit"
                 @hide="clearForm"
                 ok-title="Ок"
                 ok-variant="success"
                 cancel-title="Отмена"
                 cancel-variant="danger"
                 no-close-on-backdrop
                 @show="beforeOpen"
        >
            <label for="parentMaterial">Родительская группа материала</label>
            <v-select
                    label="name"
                    value="id"
                    :options="groups"
                    v-model="selectedParent">
            </v-select>
            <label for="name">Имя материала</label>
            <b-form-input
                    v-model="name"
                    placeholder="Клей для швов эпоксидный"
                    id="name"
                    size="sm"
            ></b-form-input>
            <label for="measures">Единица измерения</label>
            <b-form-input
                    v-model="measures"
                    placeholder="литр"
                    id="measures"
                    size="sm"
            ></b-form-input>
        </b-modal>
    </div>
</template>

<script>
    export default {
        computed: {
            groups() {
                return this.$store.state.materials.groups;
            },
            selectedMaterialId() {
                return this.$store.state.materials.selectedMaterialId;
            }
        },
        data() {
            return {
                name: null,
                selectedParent: null,
                measures: null
            }
        },
        methods: {
            clearForm() {
                this.name = null;
                this.selectedParent = null;
                this.measures = null;
            },
            async beforeOpen() {
                const material = await this.$store.dispatch(`getMaterial`, this.selectedMaterialId);
                this.setMaterial(material);
                this.$store.dispatch(`getMaterialGroups`);
            },
            setMaterial({name, parent_group, parent_group_name, measures}) {
                this.name = name;
                this.selectedParent = {
                    id: parent_group,
                    name: parent_group_name
                };
                this.measures = measures;
            },
            submit() {
                const data = {
                    name: this.name,
                    measures: this.measures,
                    parentGroup: this.selectedParent?.id
                }
                this.$store.dispatch(`editMaterial`, data)
                    .then(() => this.$store.dispatch(`getDirectory`));
            }
        },
        name: "EditMaterial"
    }
</script>

<style scoped>

</style>